import React, { useEffect, useState } from "react";

import EreAnnualVacationList from "./EreAnnualVacationList";

export default function EreAnnualVacation({ globalData, setTrigger, trigger }) {
  return (
    <div className={`p-2 `}>
      <EreAnnualVacationList
        list={globalData} //pass Data Api
        titles={[
          "S.NO.",
          "POINT OF HIRE",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "NATIONALITY",
          "ACTUAL PROFESSION",
          "VISA PROFESSION",
          "TOTAL SALARY",
          "CLIENT",
          "VISA PROVIDER",
          "IQAMA NUMBER",
          "IQAMA EXPIRY DATE",
          "ARRIVAL DATE",
          "MOBILIZATION DATE",
          "DEMOBILIZATION DATE",
          "DEMOBILIZATION COMMENTS",
          "IDLE AGING",
          " ENTRY BEFORE DATE",
          "STATUS",
          "ACTION",
        ]}
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
